import { inject, Injectable } from '@angular/core';
import { FirebaseApp } from '@angular/fire/app';
import { getStorage } from '@firebase/storage';
import { environment } from 'src/environments/environment';
import { CloudStorageService } from './cloud-storage.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorModalStorageService extends CloudStorageService {
  override storage = getStorage(
    inject(FirebaseApp),
    `gs://${environment.errorModalBucket}`
  );
}
